// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2025 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.scoringProjects.create],
        controller: () => import('./controllers/createScoringProject.controller.js'),
        guard: getPermissionsGuard([{ resource: 'portal.scoring-project', scopes: ['create'] }])
    },
    {
        path: [config.routes.scoringProjects.list],
        controller: () => import('./controllers/scoringProjectsList.controller.js'),
        guard: getPermissionsGuard([{ resource: 'portal.scoring-project', scopes: ['view'] }])
    },
    {
        path: [config.routes.scoringProjects.view],
        controller: () => import('./controllers/scoringProjectPage.controller.js'),
        guard: getPermissionsGuard([{ resource: 'portal.scoring-project', scopes: ['view'] }])
    },
    {
        path: [config.routes.scoringProjects.edit],
        controller: () => import('./controllers/editScoringProject.controller.js'),
        guard: getPermissionsGuard([{ resource: 'portal.scoring-project', scopes: ['edit'] }])
    }
];
